import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import hospice from "../../practices_images/hospice.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Hospice = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Hospice and Palliative Medicine</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting care with compassion, structure, and clarity</h3>
            <p>
              Hospice and palliative care providers support patients and families during some of the most sensitive moments in healthcare. Care must be delivered with compassion while meeting strict clinical, regulatory, and financial requirements.            
            </p>
            <p>
              We work alongside hospice and palliative care organizations to help them maintain operational clarity and stability, allowing care teams to remain focused on patients and families.
            </p>
  
            <h3>The Care Environment</h3>
            <p>
              Hospice and palliative care organizations operate under highly regulated reimbursement models and rigorous documentation standards. Providers must balance compassionate, patient centered care with precise compliance, billing accuracy, and financial oversight.
            <p>
            </p>
              The emotional weight of care delivery, combined with administrative complexity, places unique demands on staff and leadership.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help hospice and palliative care providers strengthen the operational foundations that support sustainable care delivery.
              </p>
              <p>
                Our work focuses on reinforcing documentation accuracy, supporting compliant billing and reimbursement processes, improving financial visibility, and strengthening internal controls. We take a thoughtful and disciplined approach that respects the sensitive nature of the care being delivered.            
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Stability and Transparency">
              <p>
                Our goal is to help organizations operate with confidence and transparency.
              </p>
              <p>
                By improving operational consistency and financial clarity, we support reduced administrative burden, stronger compliance, and greater organizational stability. This allows care teams to focus on delivering comfort and support without distraction.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As hospice and palliative care continue to play an essential role in the healthcare system, strong operational foundations remain critical.
              </p>
              <p>
                We partner with organizations to build the clarity, discipline, and resilience needed to support patients, families, and care teams over the long term.
              </p>
              <p>
                Let’s begin a conversation about how your organization can move forward with care and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={hospice} alt="Hospice" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default Hospice;
